export * from './share-map.service';



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/lib/share-map/shared/index.ts